import React from 'react';
import { Form } from 'react-bootstrap';

const PersonalizarPdf = (props) => {
  const { data } = props;

  const handleOnChange = (event) => {
    const { value, checked } = event.target;

    const metadataWithCheckValue = {
      Metadata: { ...data?.Metadata, [value]: checked },
    };

    props.onChange(metadataWithCheckValue);
  };

  const checked = [1, true, 'true'].includes(data?.Metadata?.pdf_sucursal);

  return (
    <>
      <div className="mt-3">
        <Form autoComplete="off">
          <Form.Check
            type="checkbox"
            id="metadata_pdf_sucursal"
            name="metadata_pdf_sucursal"
            label="Mostrar sucursal en pdf"
            value="pdf_sucursal"
            custom={true}
            checked={checked}
            onChange={handleOnChange}
          />
        </Form>
      </div>
    </>
  );
};

export default PersonalizarPdf;
